const $inject = ['$scope', '$timeout', '$rootScope'];

const lbaLeafletMapCtrl = function ($scope, $timeout, $rootScope) {
  let vm = this;
  let mapInitialised = false;
  vm.mapId = 'map' + $scope.$id;
  vm.map = null;
  vm.highlighted = null;

  vm.addMarker  = addMarker;
  vm.centerMap  = centerMap;
  vm.refreshMap = refreshMap;
  vm.highlightMarker = highlightMarker;
  vm.removeHighlight = removeHighlight;

  const defaultIcon = L.icon({
    iconUrl: require('./point-of-interest.png'),
    iconSize: [20,20],
    iconAnchor: [10,5]
  });

  const pinIcon = L.icon({
    iconUrl: require('./pushpin.png'),
    iconSize: [16,24],
    iconAnchor: [8, 24]
  });

  $rootScope.$on('leaflet.refresh', vm.refreshMap);
  $rootScope.$on('leaflet.highlight', vm.highlightMarker);
  $rootScope.$on('leaflet.removeHighlight', vm.removeHighlight);

  function highlightMarker(event, item){
    removeHighlight();
    item.marker.activate();
    vm.highlighted = item.marker;
    centerMap(item);
  }

  function removeHighlight(){
    if(vm.highlighted) vm.highlighted.deActivate();
    vm.highlighted = null;
  }

  function init(){

    let mapPos = [0,0];
    let zoomLevel = vm.zoomLevel || 14;

    if(vm.mapCenter){
      mapPos = [vm.mapCenter.latitude, vm.mapCenter.longitude];
    }
    
    vm.map = L.map(vm.mapId, {
      zoom: zoomLevel,
      center: mapPos
    });

    L.gridLayer.googleMutant({
      type: 'roadmap',
    }).addTo(vm.map);

    vm.map.attributionControl.options.prefix = '';
    mapInitialised = true;
  }

  function refreshMap(){
    if (!mapInitialised) {
      return
    }
    if(vm.circle) vm.map.removeLayer(vm.circle);
    if(vm.markers) vm.map.removeLayer(vm.markers);
    if(vm.latLongPoint) vm.map.removeLayer(vm.latLongPoint);

    $timeout(() => {
      vm.markers = L.markerClusterGroup({
        spiderfyOnMaxZoom: false,
        showCoverageOnHover: false,
        disableClusteringAtZoom: 17,
        maxClusterRadius: 30
      });
      vm.locations.forEach((l, index) => addMarker(l));
      vm.map.addLayer(vm.markers);
      vm.centerMap();
      addRadius(vm.includesRadius);
    });
  }

  function addRadius(data) {
    if (!data) {
      return
    }
    let pos = [data.lat, data.long];
    vm.latLongPoint = L.marker(pos, { icon: defaultIcon }).addTo(vm.map);
    vm.circle = L.circle(pos, vm.includesRadius).addTo(vm.map);

    $timeout(()=> {
      vm.map.fitBounds(vm.circle.getBounds());
    }, 1000);

  }

  function addMarker(l){
    let marker = createMarker(l);
    vm.markers.addLayer(marker);
  }


  function centerMap(item) {

    // leaflet and angular's digest might be causing the crash... $timeout to the rescue :)
    $timeout(() => {
      if (item) {
        vm.map.setView([item.Latitude, item.Longitude], 18);
      } else if (!vm.zoomLevel && !vm.bounds) {
        let bounds = vm.markers.getBounds();
        if (bounds._southWest) {
          vm.map.fitBounds(vm.markers.getBounds());
        }
      } else if (vm.bounds) {
        vm.map.fitBounds(vm.bounds);
        vm.bounds = false;
      }
    }, 100);
  }


  $timeout(init);


  function createMarker(l){
    const icon = pinIcon;
    let pos = [l.Latitude, l.Longitude];
    let markerContent = `<h3>${l.Title || l.Name}</h3>`;
    let marker = L.marker(pos, {icon: icon});

    if(l.Description) {
      markerContent += `<p>${ l.Description }</p>`;
    }

    markerContent += addressContent(l);

    if (vm.markerOverride) {
      if (l.Name) {
        markerContent = `<h3>${l.Name}</h3>`;
        markerContent += addressContent(l);
      } else {
        markerContent = `<h3>${vm.markerOverride.text}</h3>`
      }
      if (vm.markerOverride.ctaText) {
        markerContent = `<h3>${vm.markerOverride.text}</h3> <button class="btn btn-primary">${vm.markerOverride.ctaText}</button class="btn btn-primary">`
      }
    }

    marker.activeIcon = L.divIcon({
      className: 'my-div-icon',
      iconAnchor: [158, 24],
      iconSize: [0,0],
      html: `
            <div class="marker-active">
              <div class="icon marker-active_icon">
              </div>
              <div class="marker-active_content">
               ${markerContent}
              </div>
            </div>
          `
    });

    marker.activate = activate;
    marker.deActivate = deActivate;

    function addressContent(l) {
      let content = '';

      if(l.Address) {
        content += `<p>`;
        content += `${ l.Address }`;

        if(l.PostCode) {
          content += `, ${ l.PostCode }`;
        }

        content += `</p>`;
      }

      return content;
    }

    function activate(){
      marker.originalZIndex = marker.zIndexOffset;
      marker.setZIndexOffset(10000);
      marker.setIcon(marker.activeIcon);
    }

    function deActivate(){
      marker.setZIndexOffset(marker.originalZIndex);
      marker.setIcon(icon);
    }

    function mouseout(){
      if(!l.active){
        deActivate();
        marker.off('mouseout', mouseout);
        marker.on('mouseover', mouseover);
      }
    }

    function mouseover(){
      activate();
      marker.off('mouseover', mouseover);
      marker.on('mouseout', mouseout);
    }

    l.marker = marker;

    marker.on('mouseover', mouseover);
    marker.on('click', function(){
      console.log('lbaLeafletMapCtrl.js line:143, click:');
      vm.markerClick(l, true);
    });

    return marker;
  }

};

lbaLeafletMapCtrl.$inject = $inject;

export default lbaLeafletMapCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaLeafletMap/lbaLeafletMapCtrl.js